/*!
 * OLSKTesting
 * Copyright(c) 2018 Rosano Coutinho
 * MIT Licensed
 */

var kOLSKTasksEnableLogging = true;

//_ OLSKTestingFakeRequest

exports.OLSKTestingFakeRequest = function(inputData = {}) {
	console.warn('OLSKTestingFakeRequest DEPRECATED');
	return Object.assign({}, inputData);
};

//_ OLSKTestingFakeRequestForSession

exports.OLSKTestingFakeRequestForSession = function(inputData = {}) {
	console.warn('OLSKTestingFakeRequestForSession DEPRECATED');
	return exports.OLSKTestingFakeRequest({
		session: inputData,
	});
};

//_ OLSKTestingFakeRequestForHeaders

exports.OLSKTestingFakeRequestForHeaders = function(inputData = {}) {
	console.warn('OLSKTestingFakeRequestForHeaders DEPRECATED');
	return exports.OLSKTestingFakeRequest({
		headers: inputData,
	});
};

//_ OLSKTestingFakeResponse

exports.OLSKTestingFakeResponse = function(inputData = {}) {
	console.warn('OLSKTestingFakeResponse DEPRECATED');
	return Object.assign({}, inputData);
};

//_ OLSKTestingFakeResponseForLocals

exports.OLSKTestingFakeResponseForLocals = function(inputData = {}) {
	console.warn('OLSKTestingFakeResponseForLocals DEPRECATED');
	return exports.OLSKTestingFakeResponse({
		locals: inputData,
	});
};

//_ OLSKTestingFakeResponseForJSON

exports.OLSKTestingFakeResponseForJSON = function() {
	console.warn('OLSKTestingFakeResponseForJSON DEPRECATED');
	return exports.OLSKTestingFakeResponse({
		json: function(inputData) {
			return inputData;
		},
	});
};

//_ OLSKTestingFakeResponseForRender

exports.OLSKTestingFakeResponseForRender = function(callback) {
	console.warn('OLSKTestingFakeResponseForRender DEPRECATED');
	if (typeof callback !== 'function') {
		throw new Error('OLSKErrorInputNotValid');
	}

	return exports.OLSKTestingFakeResponse({
		render: callback,
	});
};

//_ OLSKTestingFakeResponseForRedirect

exports.OLSKTestingFakeResponseForRedirect = function() {
	console.warn('OLSKTestingFakeResponseForRedirect DEPRECATED');
	return exports.OLSKTestingFakeResponse({
		redirect: function(inputData) {
			return inputData;
		},
	});
};

//_ OLSKTestingFakeResponseForStatus

exports.OLSKTestingFakeResponseForStatus = function() {
	console.warn('OLSKTestingFakeResponseForStatus DEPRECATED');
	var res = Object.assign(exports.OLSKTestingFakeResponseForJSON(), {
		status: function(inputData) {
			res.statusCode = inputData;

			return;
		},
	});

	return res;
};

//_ OLSKTestingFakeNext

exports.OLSKTestingFakeNext = function() {
	console.warn('OLSKTestingFakeNext DEPRECATED');
	return function(inputData) {
		return typeof inputData === 'undefined' ? 'RETURNED_UNDEFINED' : inputData;
	};
};

//_ _OLSKTestingMochaReplaceES6Import

exports._OLSKTestingMochaReplaceES6Import = function(inputData) {
	const exportable = [];
	
	inputData = inputData
		.replace(/^import \* as (\w+) from ['"]([^'"]+)['"];?/gm, 'var $1 = require("$2");')
		.replace(/^import (\w+) from ['"]([^'"]+)['"];?/gm, 'var {default: $1} = require("$2");')
		.replace(/^import {([^}]+)} from ['"](.+)['"];?/gm, 'var {$1} = require("$2");')
		.replace(/^export default /gm, 'exports.default = ')
		.replace(/^export (const|let|var|class|function) (\w+)/gm, (match, type, name) => {
			exportable.push(name);
			return `${type} ${name}`;
		})
		.replace(/^export \{([^}]+)\}(?: from ['"]([^'"]+)['"];?)?/gm, (match, names, source) => {
			names.split(',').filter(Boolean).forEach(name => {
				exportable.push(name);
			});

			return source ? `const { ${names} } = require("${source}");` : '';
		})
		.replace(/^export function (\w+)/gm, 'exports.$1 = function $1');

	exportable.forEach(name => {
		inputData += `\nexports.${name} = ${name};`;
	});

	return inputData;
};

exports.OLSK_TESTING_BEHAVIOUR = function () {
	if (typeof navigator === 'undefined') {
		return false;
	}

	return navigator.appName === 'Zombie';
};
